import useDeleteOrder from './useDeleteOrder';

export default useDeleteOrder;
